export enum TagStatus {
	Open = '0',
	Sold = '1',
	Closed = '2',
}
